import { ReactNode } from 'react'

import { Button, PageHeader as PageHeaderBase } from '@domain-group/suit-theme'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

type TabBarItem = {
  icon: IconDefinition | ReactNode,
  hidden?: boolean,
  href: string,
  key: string,
  title: string,
}

interface PageHeaderProps {
  actionContent?: ReactNode,
  activeTabBarItemKey?: string,
  boxProps?: object,
  callbacks?: object,
  heading?: ReactNode,
  lowerRightContent?: ReactNode,
  nestedNavigation?: boolean,
  offset?: object,
  showBackButton?: boolean,
  tabBarItems?: TabBarItem[],
  title?: string,
  width?: string | number,
}

const PageHeader = (props: PageHeaderProps) => {
  const {
    actionContent, boxProps, nestedNavigation, offset, showBackButton, ...restProps
  } = props

  const leftOffset = !nestedNavigation ? 220 : undefined

  // @ts-expect-error TS2741
  const { redirect }: { redirect: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const shouldShowBackButton = showBackButton && !!redirect

  const contentWithBackButton = (
    <>
      {actionContent}

      <Button
        // @ts-expect-error TS2322
        as="a"
        buttonStyle="secondaryUtility"
        href={redirect}
        marginLeft="medium"
        size="medium"
        width="auto"
      >
        Back
      </Button>
    </>
  )

  return (
    <PageHeaderBase
      actionContent={shouldShowBackButton ? contentWithBackButton : actionContent}
      boxProps={{ height: [112, 105], justifyContent: 'flex-start', ...boxProps }}
      nestedNavigation={nestedNavigation}
      offset={{ left: leftOffset, ...offset }}
      {...restProps}
    />
  )
}

export default PageHeader
